import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { ReturnShippingInstructionsTitleEmailRenderer } from "./email";
import type { ReturnShippingInstructionsTitleBlockProps } from "./types";

export function ReturnShippingInstructionsTitleEditorRenderer(
  props: ReturnShippingInstructionsTitleBlockProps,
) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <ReturnShippingInstructionsTitleEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
